import {
  colors,
  Theme,
  Tooltip as MuiTooltip,
  withStyles,
} from "@material-ui/core";

const Tooltip = withStyles((theme: Theme) => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    border: `1px solid ${theme.palette.common.black}`,
    color: "rgba(0, 0, 0, 0.87)",
    boxShadow: theme.shadows[1],
    fontSize: 11,
    "& a": {
      fontSize: 11,
      color: colors.blue[500],
    },
  },
}))(MuiTooltip);

export default Tooltip;
